import _ from 'lodash'
import { Spin } from 'antd'

export default props => {
  const {
    className = 'text-secondary text-sm',
    style = {},
    loading = false,
    disabled = false
  } = props

  return (
    <a
      onClick={!loading && !disabled ? props.onClick : undefined} 
      className={`${className} ${(loading || disabled) ? 'disabled' : ''}`}
      style={style}
    >
      {loading ? <Spin size="small" style={{ marginRight: 5 }} /> : props.icon}
      <span>{props.text}</span>
      <style jsx>{`
        span {
          margin-left: 5px;
        }
        .disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
      `}</style>
    </a>
  )
}
